import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from "src/app/shared/vo/pless-request.model";

/**
 * 画像作成指示画面　画像作成指示を更新するサービス
 *
 * @export GetDelivCatalogIDService
 * @class GetDelivCatalogIDService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetDelivCatalogIDService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW0C00Model}
   * @memberof GetDelivCatalogIDService
   */

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetDelivCatalogIDService
   */
  private successFunc: Function;

  vo = {
    orderCode: '',
    deliveryWeekFixFlag: '',
  };

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetDelivCatalogIDService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.orderCode,
        DeliveryWeekFixFlag: this.vo.deliveryWeekFixFlag
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetDelivCatalogIDService
   */
  execute(model: any, successFunc: Function): void {
    this.send('getDelivCatalogID', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetDelivCatalogIDService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
